import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SizeAndMeasurements',
  setup(__props) {

const isPrivateMode = computed<boolean>(() => store.getters['app/isPrivateMode']);
const textColor = computed<OpacityFunction>(() => store.getters['app/textColor']);
const product = computed<ProductBaseViewModel<VariantBaseViewObject> | ProfessionalProductViewModel>(() => store.getters['catalog/product']);
const selectedVariant = computed<VariantBaseViewObject>(() => store.getters['catalog/selectedVariant']);

const professionalProduct = computed<ProfessionalProductViewModel>(() => {
    return !isPrivateMode.value ? (product.value as ProfessionalProductViewModel) : null;
});

return { __sfc: true,isPrivateMode, textColor, product, selectedVariant, professionalProduct }
}

})